import m from "../../../memize/dist/index.js";
function p(e, s, n = 0) {
  const r = f(e);
  r.lastIndex = n;
  const t = r.exec(s);
  if (!t)
    return;
  if (t[1] === "[" && t[7] === "]")
    return p(e, s, r.lastIndex);
  const i = {
    index: t.index,
    content: t[0],
    shortcode: a(t)
  };
  return t[1] && (i.content = i.content.slice(1), i.index++), t[7] && (i.content = i.content.slice(0, -1)), i;
}
function d(e, s, n) {
  return s.replace(f(e), function(r, t, i, o, c, b, y, h) {
    if (t === "[" && h === "]")
      return r;
    const u = n(a(arguments));
    return u || u === "" ? t + u + h : r;
  });
}
function w(e) {
  return new l(e).string();
}
function f(e) {
  return new RegExp("\\[(\\[?)(" + e + ")(?![\\w-])([^\\]\\/]*(?:\\/(?!\\])[^\\]\\/]*)*?)(?:(\\/)\\]|\\](?:([^\\[]*(?:\\[(?!\\/\\2\\])[^\\[]*)*)(\\[\\/\\2\\]))?)(\\]?)", "g");
}
const g = m((e) => {
  const s = {}, n = [], r = /([\w-]+)\s*=\s*"([^"]*)"(?:\s|$)|([\w-]+)\s*=\s*'([^']*)'(?:\s|$)|([\w-]+)\s*=\s*([^\s'"]+)(?:\s|$)|"([^"]*)"(?:\s|$)|'([^']*)'(?:\s|$)|(\S+)(?:\s|$)/g;
  e = e.replace(/[\u00a0\u200b]/g, " ");
  let t;
  for (; t = r.exec(e); )
    t[1] ? s[t[1].toLowerCase()] = t[2] : t[3] ? s[t[3].toLowerCase()] = t[4] : t[5] ? s[t[5].toLowerCase()] = t[6] : t[7] ? n.push(t[7]) : t[8] ? n.push(t[8]) : t[9] && n.push(t[9]);
  return {
    named: s,
    numeric: n
  };
});
function a(e) {
  let s;
  return e[4] ? s = "self-closing" : e[6] ? s = "closed" : s = "single", new l({
    tag: e[2],
    attrs: e[3],
    type: s,
    content: e[5]
  });
}
const l = Object.assign(function(e) {
  const {
    tag: s,
    attrs: n,
    type: r,
    content: t
  } = e || {};
  if (Object.assign(this, {
    tag: s,
    type: r,
    content: t
  }), this.attrs = {
    named: {},
    numeric: []
  }, !n)
    return;
  const i = ["named", "numeric"];
  typeof n == "string" ? this.attrs = g(n) : n.length === i.length && i.every((o, c) => o === n[c]) ? this.attrs = n : Object.entries(n).forEach(([o, c]) => {
    this.set(o, c);
  });
}, {
  next: p,
  replace: d,
  string: w,
  regexp: f,
  attrs: g,
  fromMatch: a
});
Object.assign(l.prototype, {
  /**
   * Get a shortcode attribute.
   *
   * Automatically detects whether `attr` is named or numeric and routes it
   * accordingly.
   *
   * @param {(number|string)} attr Attribute key.
   *
   * @return {string} Attribute value.
   */
  get(e) {
    return this.attrs[typeof e == "number" ? "numeric" : "named"][e];
  },
  /**
   * Set a shortcode attribute.
   *
   * Automatically detects whether `attr` is named or numeric and routes it
   * accordingly.
   *
   * @param {(number|string)} attr  Attribute key.
   * @param {string}          value Attribute value.
   *
   * @return {WPShortcode} Shortcode instance.
   */
  set(e, s) {
    return this.attrs[typeof e == "number" ? "numeric" : "named"][e] = s, this;
  },
  /**
   * Transform the shortcode into a string.
   *
   * @return {string} String representation of the shortcode.
   */
  string() {
    let e = "[" + this.tag;
    return this.attrs.numeric.forEach((s) => {
      /\s/.test(s) ? e += ' "' + s + '"' : e += " " + s;
    }), Object.entries(this.attrs.named).forEach(([s, n]) => {
      e += " " + s + '="' + n + '"';
    }), this.type === "single" ? e + "]" : this.type === "self-closing" ? e + " /]" : (e += "]", this.content && (e += this.content), e + "[/" + this.tag + "]");
  }
});
export {
  g as attrs,
  l as default,
  a as fromMatch,
  p as next,
  f as regexp,
  d as replace,
  w as string
};
//# sourceMappingURL=index.js.map
